export default "__VITE_ASSET__D$_4Hg42__"